<template>
  <transition name="el-zoom-in-center">

    <div class="attentions-zones-item">
      <div class="attentions-zones-item__text-block">
        <div class="collapse-block">
          <div
              :style="{ 'border-radius': show ? '4px 4px 0 0' : '4px'}"
              class="collapse-block__header header">
            <icon-list
                v-if="!item.code"
                class="header__icon"
            ></icon-list>
            <el-image
                v-else
                class="header__icon"
                fit="cover"
                :src="item.icon"
            />

            <el-select
                v-model="item.code"
                @change="editItem"
                placeholder="Выберите систему..."
                class="header__select">
              <el-option
                  v-for="(item, index) in types"
                  :key="index"
                  :label="item.title"
                  :value="item.code">
                <div style="display: flex; align-items: center;">
                  <img width="30" :src="item.icon">
                  <span style="padding-left: 10px; color: #111; font-size: 13px">{{ item.title }}</span>
                </div>
              </el-option>
            </el-select>

          </div>
          <el-collapse-transition>
            <div v-if="show" class="collapse-block__content">
              <el-input
                  v-model="item.zones"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5}"
                  placeholder="Напишите комментарий..."
              />
            </div>
          </el-collapse-transition>
        </div>
      </div>
      <div class="attentions-zones-item__btn">
        <el-button @click="deleteItem" type="danger" icon="el-icon-delete"></el-button>
      </div>

    </div>
  </transition>

</template>

<script>
import IconList from "@/components/icons/List.vue"

export default {
  name: 'AttentionZonesItem',
  props: {
    item: {},
    index: null,
    types: {},
  },
  components: {
    IconList
  },
  computed: {
    valueIcon() {
      return this.types.find(item => item.code === this.select)?.icon
    }
  },
  data() {
    return {
      show: true,
      editable: false,
      value: '',
      select: null
    }
  },
  methods: {
    deleteItem() {
      this.$emit('delete')
    },
    editItem(newValue) {
      this.$emit('editItem', this.index, {...this.item, ...this.types.find(item => item.code === newValue)})
    }
  }
}
</script>

<style lang="scss" scoped>
.attentions-zones-item {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 10px;
  margin-bottom: 16px;

  &__text-block {
    flex: 1;
  }

  &__btn {
    width: 40px;
  }
}

.collapse-block {
  width: 100%;
  border-radius: 4px;

  &__header {
    background: #F6F8F9;
    padding: 8px 0 8px 16px;
    transition: all 0.5s ease;
  }

  &__content {
    border: 1px solid #E4E7ED;
    border-radius: 0 0 4px 4px;

    /deep/ {
      .el-textarea__inner {
        border: 0 !important;
      }
    }
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: start;

  &__select {
    width: 100%;

    /deep/ {
      .el-input__inner {
        border: 0 !important;
        background: transparent;

        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        color: #111;
      }
    }
  }

  &__icon {
    width: 24px;
    max-height: 24px;
  }
}

</style>